import React, { useEffect, useLayoutEffect, useRef, useState } from 'react';
import { PropTypes } from 'prop-types';
import AccionaTooltip from '../AccionaTooltip';
import { useIntl } from 'react-intl';
import { createPortal } from 'react-dom';
import styles from './index.module.scss';

const { labelGroup } = styles;

const AccionaFormItem = ({
  children,
  style,
  hidden,
  forceTooltip,
  extra,
  enableTooltips,
}) => {
  const intl = useIntl();
  const ref = useRef();
  const [showToolTip, setShowToolTip] = useState(false);
  const [dropdownPosition, setDropdownPosition] = useState({ left: 0, top: 0 });

  useEffect(() => {
    let timeoutId = null;

    const handleScroll = (e) => {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
      const rect = ref.current.getBoundingClientRect();

      setShowToolTip(false);
      setDropdownPosition({
        top: rect.top + window.scrollY,
        left: rect.left + window.scrollX,
      });

      timeoutId = setTimeout(() => {
        if (ref.current) {
          setDropdownPosition({
            top: rect.top + window.scrollY,
            left: rect.left + window.scrollX,
          });
        }
      }, 100); // Delay in milliseconds
    };

    window.addEventListener('scroll', handleScroll, true);

    // Execute once on mount
    handleScroll({ target: document.body });

    return () => {
      window.removeEventListener('scroll', handleScroll, true);
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
    };
  }, []);

  useEffect(() => {
    if (children.props.state.status.length && forceTooltip && enableTooltips)
      setShowToolTip(forceTooltip);
  }, [forceTooltip, children.props.state.status.length, enableTooltips]);

  useLayoutEffect(() => {
    if (showToolTip) {
      const rect = ref.current.getBoundingClientRect();
      setDropdownPosition({
        top: rect.top,
        left: rect.left,
      });
    }
  }, [showToolTip]);

  return (
    <div
      onMouseOver={() => {
        if (enableTooltips) setShowToolTip(true);
      }}
      onMouseOut={() => {
        if (enableTooltips) setShowToolTip(false);
      }}
      id={`div-tooltip-${children.props.label || 'tooltip'}`}
      hidden={hidden}
      className="form-row text-label input-gray"
      style={style}
      ref={ref}
    >
      {showToolTip &&
        createPortal(
          <AccionaTooltip
            label={children.props.label || ' '}
            status={children.props.state.status}
            showToolTip={showToolTip}
            style={{
              position: 'absolute',
              top: dropdownPosition.top,
              left: dropdownPosition.left,
              zIndex: 900,
            }}
          />,
          document.body,
        )}
      <div className={labelGroup}>
        <label
          id={`label-tooltip-${children.props.label || 'tooltips'}`}
          htmlFor={children.props.label || 'label'}
        >
          {children.props.label
            ? intl.formatMessage({ id: children.props.label })
            : ''}{' '}
          {children.props.extraLabel && (
            <span>{children.props.extraLabel}</span>
          )}
        </label>
        {extra && <span>{extra}</span>}
      </div>
      {children.props.state ? (
        <div className={children.props.state.status.length ? 'input-err' : ''}>
          {children}
        </div>
      ) : (
        children
      )}
    </div>
  );
};

AccionaFormItem.propTypes = {
  children: PropTypes.element.isRequired,
  style: PropTypes.object,
  forceTooltip: PropTypes.bool,
  hidden: PropTypes.bool,
  extra: PropTypes.element,
  enableTooltips: PropTypes.bool,
};

AccionaFormItem.defaultProps = {
  forceTooltip: true,
  style: {},
  hidden: false,
  extra: undefined,
  enableTooltips: true,
};
export default AccionaFormItem;
